import * as React from "react";
import Input from "../Input-new/Input";
import Dropdown from "../Dropdown/Dropdown";
import SelectCompany from "../SelectCompany/SelectCompany";

const InvestorCompanyInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown, 
  viewMode,
  deleted,
}) => {
  return (
    <div className="Buyer-company-info">
      <div className="Buyer-company-info_column">
        <SelectCompany
          className="Buyer-company-info_column_item"
          value={data.company_name}
          valueKey="company_name"
          label="Company Name"
          data={data}
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="company_address"
          label="Address"
          value={data.company_address}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="company_city"
          label="City"
          value={data.company_city}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Dropdown
          className="Buyer-company-info_column_item"
          data={data}
          optionsType="states"
          optionKey="abbr"
          optionLabelKey="name"
          value={data.company_state}
          valueKey="company_state"
          label="State"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-company-info_column_item"
          valueType="text"
          name="company_zip"
          label="Zip"
          value={data.company_zip}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Firm-info_column_item"
          valueType="text"
          name="website"
          label="WEBSITE"
          value={data.website}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
    </div>
  );
};

export default InvestorCompanyInfo;
